import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler';
import { headerJson } from '../_helpers/auth-header';

import {config} from '../config';
const base_url = config.appApiUrl;

const model = 'Cities/';

export const citiesService = {
  getAll,
};

function getAll(id) {
  const url = base_url + model + "getAll/" + id;
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: headerJson()});
}
